export const LOGIN_USER = "LOGIN_USER";
export const LOCAL_STORAGE_TOKEN_LOGIN = "LOCAL_STORAGE_TOKEN_LOGIN";
